import { Link } from "react-router-dom";
import { Compass, Users, Zap, Layers, Anchor, ArrowRight } from "lucide-react";

const PILLARS = [
  {
    icon: Compass,
    color: "#67E8F9",
    title: "On clarifie votre cap",
    desc: "Positionnement, vision, plan d'action chiffré : on transforme l'intuition en feuille de route bancable.",
  },
  {
    icon: Layers,
    color: "#FFDCA8",
    title: "On bâtit vos outils",
    desc: "Site, app, CRM, ERP, dashboards : on construit ce qui vous manque pour scaler — sur-mesure et opéré.",
  },
  {
    icon: Zap,
    color: "#A7F3D0",
    title: "On accélère vos ventes",
    desc: "Landing pages de capture, campagnes multi-canal, SEO assisté, tracking : chaque euro investi mesurable.",
  },
  {
    icon: Anchor,
    color: "#06B6D4",
    title: "On reste à vos côtés",
    desc: "Pas une prestation one-shot : un suivi continu via votre Espace Entreprise, devis, factures, briefs, RDV.",
  },
];

export default function CopilotSection() {
  return (
    <section id="qui" className="py-20 sm:py-28 bg-white relative" data-testid="copilot-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Left: pitch */}
          <div className="lg:col-span-5">
            <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#06B6D4]">Notre rôle</div>
            <h2 className="display mt-3 text-4xl sm:text-5xl text-[#0A1128] font-extrabold leading-[1.05]">
              Ensemble, <span className="text-[#06B6D4]">en direction de vos objectifs</span>.
            </h2>
            <p className="mt-5 text-[#475569] text-lg leading-relaxed">
              Vous pilotez. Nous embarquons. Nous structurons votre activité comme si c'était la nôtre : décisions partagées, outils communs, exécution rapide.
            </p>

            <div className="mt-8 bg-[#0A1128] text-white rounded-3xl p-6 relative overflow-hidden">
              <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-25" style={{ background: "#67E8F9", filter: "blur(80px)" }} />
              <div className="relative">
                <Users size={28} className="text-[#67E8F9]" />
                <h3 className="display mt-3 text-2xl font-extrabold">Qui nous accompagnons</h3>
                <p className="text-white/70 text-sm mt-2">Vous êtes <b className="text-white">entrepreneur, dirigeant, porteur d'idée</b>, à la tête d'une ou plusieurs entreprises. Vous voulez un partenaire qui pense business avec vous, et qui livre.</p>

                <Link to="/portail/connexion" data-testid="copilot-cta-espace" className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#06B6D4] hover:bg-[#67E8F9] text-[#0A1128] font-extrabold text-sm transition-colors">
                  Créer mon Espace Entreprise <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          </div>

          {/* Right: 4 pillars */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {PILLARS.map((p, i) => (
                <div key={p.title} data-testid={`copilot-pillar-${i}`} className="relative bg-[#FAFAFA] rounded-2xl p-6 border border-black/8 hover:shadow-xl hover:-translate-y-1 transition-all">
                  <div className="absolute -top-3 -left-3 w-12 h-12 rounded-xl flex items-center justify-center shadow-md" style={{ background: p.color }}>
                    <p.icon size={20} className="text-[#0A1128]" />
                  </div>
                  <div className="mt-6">
                    <h3 className="display text-lg font-extrabold text-[#0A1128]">{p.title}</h3>
                    <p className="mt-2 text-sm text-[#475569] leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
